(function ($, window) {
    'use strict';
    var $finderTop;
    var $filterReset;
    window.geMomentive = window.geMomentive || {};
    geMomentive.productFinder = (function () {
        function _filterReset() {
            $filterReset = $('.reset-filter');

            $filterReset.on('click', function (event) {
                // console.log(this);
                event.preventDefault();
                $('.drilldown').drilldown('reset');
            });
        }
        function init() {
            _filterReset();
            $('.drilldown').drilldown();
        }
        return {
            init: init
        };
    })();
        geMomentive.productFinder.init();
})(jQuery, window);
